(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9603],{

/***/ 5243:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search",
      function () {
        return __webpack_require__(7710);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ SearchPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8029);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7294);
/* harmony import */ var _components_SectionView__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(570);
/* harmony import */ var _containers_Helmet__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9536);
/* harmony import */ var _layout_Footer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3981);
/* harmony import */ var _layout_HeaderV3__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4850);
/* harmony import */ var _utils_hooks__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1127);
/* harmony import */ var _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9741);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}











var __N_SSG = true;
function SearchPage(param1) {
    var header = param1.header, hotelBrands = param1.hotelBrands;
    var ref = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)(), isReady = ref.isReady, query = ref.query, push = ref.push, locale = ref.locale;
    var ref1 = _slicedToArray((0,_utils_hooks__WEBPACK_IMPORTED_MODULE_9__/* .useFetchSWRv2 */ .bX)("rooms", {
        _cct_search: query.keyword,
        cct_status: "publish"
    }), 3), itemTemp = ref1[0], isLoading = ref1[1], isError = ref1[2];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(), items = ref2[0], setItem = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (isReady && query.keyword) {
            if (itemTemp) {
                var temp = itemTemp;
                if (locale == "id") {
                    var x = JSON.stringify(itemTemp);
                    var y = x.replace(/_id/g, "");
                    temp = JSON.parse(y);
                } else {
                    var x1 = JSON.stringify(itemTemp);
                    var y1 = x1.replace(/_en/g, "");
                    temp = JSON.parse(y1);
                }
                setItem(temp);
            }
        } else {
        // push(`/`);
        }
    }, [
        locale,
        itemTemp
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_containers_Helmet__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                title: "Search - ".concat(query.keyword ? query.keyword : "~", " | Parador Hotels & Resorts")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_HeaderV3__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                headerItem: header,
                isHomepage: false,
                hotelBrands: hotelBrands
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Center */ .M5Y, {
                px: _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_10__/* .safeMarginX */ .Mp,
                my: _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_10__/* .safeMarginX */ .Mp,
                flexDirection: "column",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Heading */ .X6q, {
                    mb: 3,
                    as: "h1",
                    fontSize: "3xl",
                    textTransform: "none",
                    fontWeight: 400,
                    color: header.color_primary,
                    textAlign: "center",
                    maxW: {
                        base: "90%",
                        md: "70%"
                    },
                    letterSpacing: "widest",
                    children: locale == "id" ? 'Hasil Pencarian untuk "'.concat(query.keyword ? query.keyword : "-", '"') : 'Search Results for "'.concat(query.keyword ? query.keyword : "-", '"')
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                px: _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_10__/* .safeMarginX */ .Mp,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Divider */ .izJ, {
                    orientation: "horizontal",
                    borderColor: "blackAlpha.400"
                })
            }),
            !isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SectionView__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                type: "rooms",
                title: items ? locale == "id" ? 'DITEMUKAN "'.concat(items.length, '" ITEM') : 'NUMBER FOUND "'.concat(items.length, '"') : "",
                color: header.color_primary,
                items: items ? items.map(function(param) {
                    var _ID = param._ID, name = param.name, thumbnail = param.thumbnail, desc_short = param.desc_short, bed_type = param.bed_type, room_size = param.room_size, start_from = param.start_from, total_guest = param.total_guest, room_name_id = param.room_name_id, room_size_manual = param.room_size_manual;
                    return {
                        thumb: thumbnail,
                        _ID: _ID,
                        desc: desc_short,
                        title: locale == "id" && !(0,lodash__WEBPACK_IMPORTED_MODULE_2__.isEmpty)(room_name_id) ? room_name_id : name,
                        bed_type: bed_type,
                        room_size: (0,lodash__WEBPACK_IMPORTED_MODULE_2__.isEmpty)(room_size_manual) ? room_size : room_size_manual,
                        start_from: start_from,
                        total_guest: total_guest
                    };
                }) : [],
                targetItems: items ? items.map(function(param) {
                    var _ID = param._ID, hotel_name = param.hotel_name;
                    return "/".concat((0,lodash__WEBPACK_IMPORTED_MODULE_2__.lowerCase)(hotel_name).replace(/\s/g, "-"), "/rooms/").concat(_ID);
                }) : []
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Center */ .M5Y, {
                h: "50vh",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Spinner */ .$jN, {
                    size: "xl"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                h: 10
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_Footer__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                loc: header.location_url,
                address: header.location_long,
                email: header.email,
                phone: header.phone
            })
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5445,5525,4939,3981,570,9774,2888,179], function() { return __webpack_exec__(5243); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);